import { customerRoutePush } from "@customer-gallery/definitions/routeDefinitions";
import { claimTokenLineItem } from "@customer-gallery/redux/actionCreators/unclaimedTokens";
import { NovelGalleryThunkAction } from "@customer-gallery/redux/galleryTypedRedux";
import { asyncDispatch } from "@customer-gallery/redux/utils/asyncDispatch";
import { ICryptoWalletAddConnectionReqBody } from "@novel/shared/interfaces/CryptoWallet";
import { loadingToast } from "@novel/shared/utils/toastUtils";
import { typedFrontendGalleryApi } from "@customer-gallery/utils/typedFrontendGalleryApi";

export const connectWallet =
    ({
        wallet,
    }: ICryptoWalletAddConnectionReqBody): NovelGalleryThunkAction<
        | "CONNECTING_WALLET"
        | "ERROR_CONNECTING_WALLET"
        | "CONNECTED_WALLET"
        | "LOADING_CLAIMING_TOKEN_LINE_ITEM"
        | "ERROR_LOADING_CLAIMING_TOKEN_LINE_ITEM"
        | "LOADED_CLAIMING_TOKEN_LINE_ITEM"
    > =>
    async (dispatch, getState) => {
        const { onSuccessToast, onErrorToast } = loadingToast("Connecting Wallet...");

        return asyncDispatch(
            typedFrontendGalleryApi.postReq("/api/customer/crypto-wallet", {
                reqBody: {
                    wallet,
                },
            }),
            () =>
                dispatch({
                    type: "CONNECTING_WALLET",
                    payload: undefined,
                }),
            (failure) => {
                onErrorToast(failure.error.message);
                return dispatch({
                    type: "ERROR_CONNECTING_WALLET",
                    payload: {
                        errorMessage: failure.error.message,
                    },
                });
            },
            async ({ wallet }) => {
                onSuccessToast("Wallet Connected!");

                // if more than one evm address, don't auto-claim because we don't know which one to claim
                const evmCryptoAddresses = wallet.cryptoAddresses.filter(
                    (address) => address.blockchainType === "evm",
                );
                const isFirstEvmAddress =
                    getState().addresses.cryptoAddresses.every(
                        (address) => address.blockchainType !== "evm",
                    ) && evmCryptoAddresses.length === 1;

                const result = dispatch({
                    type: "CONNECTED_WALLET",
                    payload: { wallet },
                });

                const { unclaimedTokens } = getState().unclaimedTokens;

                let returnResult: Promise<any> | null = null; // hacking with "any" because the type is not exposed
                if (isFirstEvmAddress && unclaimedTokens.length === 1) {
                    returnResult = dispatch(
                        claimTokenLineItem(evmCryptoAddresses[0], wallet, unclaimedTokens[0]),
                    );
                }

                // if wallet was just connected from manage
                if (typeof window !== "undefined" && window.location.pathname.includes("/manage")) {
                    customerRoutePush(
                        "/",
                        {},
                        !!getState().addresses.cryptoAddresses.length &&
                            wallet.cryptoAddresses.length !== 1
                            ? {}
                            : {
                                  address: wallet.cryptoAddresses[0].address,
                              },
                    );
                }

                if (returnResult) {
                    return await returnResult;
                }
                return result;
            },
        );
    };
